export function isClient () {
  return typeof window !== 'undefined' && window.document;
}


// WEBPACK FOOTER //
// ./common/Utils/isClientUtil.js